/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { OneDSubstanceConcentration } from "./OneDSubstanceConcentration";
import {
  OneDSubstanceConcentrationFromJSON,
  OneDSubstanceConcentrationFromJSONTyped,
  OneDSubstanceConcentrationToJSON,
  OneDSubstanceConcentrationToJSONTyped,
} from "./OneDSubstanceConcentration";

/**
 *
 * @export
 * @interface PaginatedOneDSubstanceConcentrationList
 */
export interface PaginatedOneDSubstanceConcentrationList {
  /**
   *
   */
  count: number;
  /**
   *
   */
  next?: string | null;
  /**
   *
   */
  previous?: string | null;
  /**
   *
   */
  results: Array<OneDSubstanceConcentration>;
}

/**
 * Check if a given object implements the PaginatedOneDSubstanceConcentrationList interface.
 */
export function instanceOfPaginatedOneDSubstanceConcentrationList(
  value: object
): value is PaginatedOneDSubstanceConcentrationList {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function PaginatedOneDSubstanceConcentrationListFromJSON(
  json: any
): PaginatedOneDSubstanceConcentrationList {
  return PaginatedOneDSubstanceConcentrationListFromJSONTyped(json, false);
}

export function PaginatedOneDSubstanceConcentrationListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PaginatedOneDSubstanceConcentrationList {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(OneDSubstanceConcentrationFromJSON),
  };
}

export function PaginatedOneDSubstanceConcentrationListToJSON(
  json: any
): PaginatedOneDSubstanceConcentrationList {
  return PaginatedOneDSubstanceConcentrationListToJSONTyped(json, false);
}

export function PaginatedOneDSubstanceConcentrationListToJSONTyped(
  value?: PaginatedOneDSubstanceConcentrationList | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(OneDSubstanceConcentrationToJSON),
  };
}
